import { RootState } from '../index';
import { createDraftSafeSelector } from '@reduxjs/toolkit';
import { mapFinancialSummaryInfos } from './utils';
import { selectCurrencyArray } from '../currency/selectors';
import { mapFinancialSummaryInfo } from '../utils/utils';

const projects = (state: RootState) => state.archive.projects;
const loading = (state: RootState) => state.archive.loading;

export const selectProjects = createDraftSafeSelector(
  projects,
  selectCurrencyArray,
  (projects, currencies) => {
    return projects.map((project) => {
      const financialSummaryInfos = mapFinancialSummaryInfos(
        project,
        currencies,
      );
      const financialSummaryInfo = mapFinancialSummaryInfo(
        project.financialSummaryInfo,
      );
      return {
        ...project,
        ...financialSummaryInfo,
        ...financialSummaryInfos,
      };
    });
  },
);

export const selectLoading = createDraftSafeSelector(
  loading,
  (loading) => loading,
);
